var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import 'emoji-mart/css/emoji-mart.css';
import { SylController, SylPlugin } from '@syllepsis/adapter';
import React from 'react';
import ReactDOM from 'react-dom';
import { EmojiPicker } from '../../component';
var EmojiController = /** @class */ (function (_super) {
    __extends(EmojiController, _super);
    function EmojiController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toolbar = {
            getRef: function (btnDOM) {
                if (!btnDOM)
                    return;
                var dom = document.createElement('div');
                var extraDom = (React.createElement(EmojiPicker, { mountDOM: btnDOM, editor: _this.editor, backgroundImageFn: _this.props.backgroundImageFn }));
                btnDOM.appendChild(dom);
                ReactDOM.render(extraDom, dom);
            },
            handler: function () { },
        };
        return _this;
    }
    return EmojiController;
}(SylController));
var EmojiPlugin = /** @class */ (function (_super) {
    __extends(EmojiPlugin, _super);
    function EmojiPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'emoji';
        _this.Controller = EmojiController;
        return _this;
    }
    return EmojiPlugin;
}(SylPlugin));
export { EmojiController, EmojiPlugin };
//# sourceMappingURL=index.js.map